gsap.registerPlugin(ScrollTrigger);

gsap.to(
  ".expanding-row", {
  width: "100%",
  scrollTrigger: {
    trigger: ".shop-the-look",
    start: "top bottom",
    end: "bottom bottom-=1000",
    scrub: .5,
  },
});

gsap.to([
  ".expanding-row"
], {  
  borderRadius: "0",
  scrollTrigger: {
    trigger: ".shop-the-look",
    start: "center bottom",
    end: "bottom bottom-=1000",
    scrub: .5,
  },
});
